function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "E53E68AA-AF2F-4CC3-AB8C-CCF01738B610");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Admissions",
  strokeWidth: 1,
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "anuAdmissionsCareerInfoTabletNavMenu",
  transform: "translate(-228.000000, -221.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "navigationNavTabBar",
  transform: "translate(90.000000, 205.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "navTabTablet1",
  transform: "translate(138.000000, 11.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "iconCheckMark",
  transform: "translate(0.000000, 5.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.11538571,14 C4.87348329,13.9989636 4.64275412,13.8642567 4.47826064,13.6280272 L0.236578638,7.61834152 C-0.0936049214,7.14969293 -0.0760211421,6.41328906 0.275853523,5.97352421 C0.627728102,5.53376517 1.18064095,5.55718434 1.51082884,6.025833 L5.10665804,11.128835 L12.446688,0.434616747 C12.7485019,-0.0659422732 13.2978443,-0.145861793 13.6736774,0.256112946 C14.0495113,0.658087686 14.1095172,1.38973611 13.8077032,1.89029411 C13.7861307,1.92607208 13.7629866,1.96011747 13.7383922,1.99225139 L5.76123712,13.6164016 C5.59827802,13.856932 5.36734375,13.9959708 5.12411209,14 L5.11538571,14 Z"
}))))));

var SvgCheckMark = function SvgCheckMark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheckMark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/check-mark.e1cf5c34.svg";
export { ForwardRef as ReactComponent };